import "react";
import { jsx as e, jsxs as r } from "react/jsx-runtime";
var d = (o) => /* @__PURE__ */ e("svg", {
  fill: "none",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ...o,
  children: /* @__PURE__ */ r("g", {
    stroke: "#847013",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    children: [
      /* @__PURE__ */ e("path", {
        clipRule: "evenodd",
        d: "m14.0288 4.13919 7.659 13.40401c.89 1.558-.235 3.497-2.029 3.497h-15.31804c-1.795 0-2.92-1.939-2.029-3.497l7.659-13.40401c.89704-1.571 3.16104-1.571 4.05804 0z",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ e("path", { d: "m12 13.12v-3.74" }),
      /* @__PURE__ */ e("path", { d: "m11.999 16.125c-.138 0-.25.112-.249.25 0 .138.112.25.25.25s.25-.112.25-.25-.112-.25-.251-.25" })
    ]
  })
});
export {
  d as default
};

//# sourceMappingURL=Warning.js.map